import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import { IWarningMessage } from './models'

import styles from './InconsistencyWrapper.module.scss'

interface IProps extends PropsWithChildren {
  warningMessages: IWarningMessage[]
  showWarning: boolean
}
const getWarningValuesTranslations = (warningValues: string[]) =>
  warningValues.map((text) => <Translation key={text} span text={text} />)

export const InconsistencyWrapper = ({ children, warningMessages, showWarning }: IProps) => {
  const warningContent = warningMessages.map((warn, index) => {
    if (warn.values) {
      return (
        <div key={index}>
          <Translation span text={warn.text} /> &nbsp;
          {getWarningValuesTranslations(warn.values)}
        </div>
      )
    }
    return <Translation key={index} span text={warn.text} />
  })

  if (showWarning) {
    return (
      <Tooltip tipContent={() => <div>{warningContent}</div>}>
        <div className={styles.wrap}>
          <i className={classNames('kbase kbase-warning-alt', styles.icon)} />
          {children}
        </div>
      </Tooltip>
    )
  }

  return <>{children}</>
}
